import { useState } from "react";
import { useParams } from "react-router-dom";
import { StyledButtonMain } from "../common/Buttons";
import { axiosInstance } from "../../utils/networking";

/**
 * Public unsubscribe page for a custom-list (external) broadcast contact.
 * Sibling of `Unsubscribe.tsx`, which handles the firm-level opt-out.
 */
const UnsubscribeContact = () => {
  const { contactId } = useParams<{ contactId: string }>();
  const [state, setState] = useState<"idle" | "sending" | "done" | "error">(
    "idle",
  );

  const unsubscribeContact = () => {
    if (!contactId) {
      setState("error");
      return;
    }
    setState("sending");
    axiosInstance
      .post(`/user/unsubscribe/one-click/contact/${contactId}`)
      .then(() => setState("done"))
      .catch((err) => {
        console.error("Unsubscribe failed:", err);
        setState("error");
      });
  };

  if (state === "done") {
    return (
      <div>
        <h1>You've been unsubscribed</h1>
        <br></br>
        <p>
          You will no longer receive emails from Oakland Thrive at this address.
        </p>
      </div>
    );
  }

  return (
    <div>
      <h1>Unsubscribe from all the communication from Oakland Thrive?</h1>
      <br></br>
      <p>
        Confirm below and we'll stop sending email to this address.
      </p>
      <br></br>
      <StyledButtonMain
        variant="contained"
        onClick={unsubscribeContact}
        disabled={state === "sending" || !contactId}
      >
        {state === "sending" ? "Unsubscribing…" : "Unsubscribe"}
      </StyledButtonMain>
      {(state === "error" || !contactId) && (
        <p style={{ color: "#d32f2f", marginTop: "1rem" }}>
          We couldn't process that request. The link may be invalid or expired.
        </p>
      )}
    </div>
  );
};

export default UnsubscribeContact;
